export const translations = {
  filtersTitle: {
    pt: 'Filtro',
    en: 'Filter',
    es: 'Filtro',
    de: 'Filter',
  }
}